import { jsx } from 'react/jsx-runtime';

const SvgActionPlayFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M19.5 12 5 3.63v16.74L19.5 12Z" }) }));

export { SvgActionPlayFill as default };
//# sourceMappingURL=ActionPlayFill.es.js.map
